import { IOption } from '@shared/models/icommons.model';
import { ISearchFilterSettings } from '@shared/models/isearch-filter-settings.model';

export const connectFilters = (catalogs: ISearchFilterSettings[], userFilters: ISearchFilterSettings[]) => {
  // clear checked
  return catalogs
    .map(catalog => ({ ...catalog, filters: catalog.filters.map(f => ({ ...f, checked: false })) }))
    .map(({ title, sectionId, filters }) => {
      const userSelection = userFilters.find(usrFilter => usrFilter.title === title);
      if (!!userSelection) {
        return {
          title,
          sectionId,
          filters: [
            ...filters.map(filterItem =>
              Object.assign(
                filterItem,
                // MIQ-9410 display filter/column as they come from catalog endpoint
                {
                  // mark as checked if filterItem is included in user filter selection
                  checked: userSelection.filters.some(
                    usrFilter =>
                      usrFilter.key === filterItem.key ||
                      (filterItem.selectItemsInGroup &&
                        usrFilter.selectItemsInGroup &&
                        usrFilter.group_key === filterItem.group_key)
                  ),
                }
              )
            ),
          ],
        };
      }
      return { title, sectionId, filters };
    });
};

export const addCheckedProperty = (filter: IOption): IOption => {
  return Object.defineProperty(filter, 'checked', {
    value: true,
    writable: true,
    enumerable: true,
    configurable: true,
  });
};

export const cleanUserFilters = (userFilters: ISearchFilterSettings[]): ISearchFilterSettings[] => {
  return userFilters.filter(toClean => toClean.filters.length > 0);
};
